<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">编号:</div>
                <el-input v-model="conditionData.caseNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">姓名:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">电话:</div>
                <el-input v-model="conditionData.Phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">所属机构:</div>
                <el-input v-model="conditionData.MechanismName" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">派驻公司:</div>
                <el-input v-model="conditionData.Company" size="small" placeholder="请输入"></el-input>
            </div>
            <!-- <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.FinancialStatus" size="small" placeholder="请选择"  class="citem-input">
                    <el-option
                    v-for="item in financialStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="item">
                <div class="label">记录状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择"  class="citem-input">
                    <el-option
                    v-for="item in financeStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">创建时间:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.EndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div class="handle-r">
                    <!-- <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel()">下载批量新增模板</el-button>
                    <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="importExcel"
                        >
                        <el-button type="success" icon="el-icon-upload" size="small" style="margin:0 10px">导入excel</el-button>
                    </el-upload>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogF()">新建</el-button> -->

                    <el-button type="info" icon="el-icon-circle-plus" size="small" @click="exportExcel()">导出Excel</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="dateStr"
                label="年月"
                align="center"
                width="150px"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="编号"
                align="center"
                width="250px"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="姓名"
                align="center"
                width="120px"
                >
                
                </el-table-column>
                <el-table-column
                prop="phone"
                label="电话"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构"
                align="center"
                width="270px"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="派驻公司"
                align="center"
                width="250px"
                >
               
                </el-table-column>
                <el-table-column
                prop="district"
                label="地区"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                prop="bzFee"
                label="标准公估费"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="sjFee"
                label="实际公估费"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="记录状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==0">未开票未回款</span>
                    <span v-else-if="scope.row.financeState==1">未完成未开票</span>
                    <span v-else-if="scope.row.financeState==2">已完成未开票</span>
                    <span v-else-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-else-if="scope.row.financeState==20">已开票部分回款</span>
                    <span v-else-if="scope.row.financeState==30">回款完成</span>
                    <span v-else-if="scope.row.financeState==40">回款未开票</span>
                    <span v-else-if="scope.row.financeState==50">红冲</span>
                    <span v-else-if="scope.row.financeState==60">作废</span>
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="pgTs"
                label="创建时间"
                align="center"
                width="100px"
                >
                </el-table-column> -->
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editDialog(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteItem(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>
           

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="1000px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        年月:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addData.date"
                        type="month"
                        placeholder="选择月">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.mechanismName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary"  size="small" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻公司:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.company" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻人员:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        电话:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleAddRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        标准公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.bzFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.sjFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        记录状态:
                    </div>
                    <div class="value">
                        <el-select v-model="addData.financeState" size="small" placeholder="请选择"  class="citem-input">
                            <el-option
                            v-for="item in financeStateAddList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        备注:
                    </div>
                    <div class="value" style="width:610px">
                        <el-input v-model="addData.remark" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in addData.paths" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else
                        @click="showImg(item.path,addData.paths)"
                        :fit="cover"></el-image>
                        <img src="../../../assets/images/icon08.png" class="close" @click="clearAllItemMaterial(index)" alt="">
                        <div class="filename">{{item.fileName}}</div>
                    </div>
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadFile"
                        >
                        <el-button type="primary" icon="el-icon-upload" style="margin-left:10px">上传附件</el-button>
                    </el-upload>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addPersonFeeRecord">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="1000px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        年月:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="updateData.date"
                        type="month"
                        placeholder="选择月">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.mechanismName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary"  size="small" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻公司:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.company" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        派驻人员:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        电话:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleUpdateRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        标准公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.bzFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        实际公估费:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.sjFee" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        记录状态:
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.financeState" size="small" placeholder="请选择"  class="citem-input">
                            <el-option
                            v-for="item in financeStateAddList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        备注:
                    </div>
                    <div class="value" style="width:610px">
                        <el-input v-model="updateData.remark" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in updateData.paths" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else
                        @click="showImg(item.path,updateData.paths)"
                        :fit="cover"></el-image>
                        <img src="../../../assets/images/icon08.png" class="close" @click="clearAllItemMaterial(index)" alt="">
                        <div class="filename">{{item.fileName}}</div>
                    </div>
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadFile"
                        >
                        <el-button type="primary" icon="el-icon-upload" style="margin-left:10px">上传附件</el-button>
                    </el-upload>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updatePerson">确 定</el-button>
                </div>
            </div>
        </el-dialog>
      
        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="1000px">
            <div class="condition">
                <div class="item">
                    <div class="label">机构名称:</div>
                    <el-input v-model="conditionDataMechanism.Name" size="small" placeholder="请输入机构名称"></el-input>
                </div>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectDataMechanism()">查询</el-button>
                    <el-button type="" size="small" @click="resetMechanism()">重置</el-button>
                </div>
            </div>
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            style="width:100%"
            height="400px"
            >
            <!-- <el-table-column
            type="selection"
            align="center"
            width="55">
            </el-table-column> -->
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="jianCheng"
            label="分机构简称"
            align="center"
            width="150px"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" @click="selectMechanism(scope.row)" icon="el-icon-edit-outline">确 定</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeMechanism"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCountMechanism"
                    :current-page="conditionDataMechanism.page"
                    :page-size="conditionDataMechanism.pageSize">
                </el-pagination>
            </div>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
            </div>
        </el-dialog>


        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import { auditStatusList } from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            district:'',
            options:regionData,
            addData:{
                paths:[],
            },
            updateData:{},
            auditStatusList:auditStatusList,
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                caseNo:'',
                Name:null,
                Phone:null,
                MechanismName:null,
                Company:null,
                StartTime:'',
                EndTime:'',
                page:1,
                pageSize:10,
                MechanismId: null
            },
            isAddDialog:false,
            isUpdateDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],
            conditionDataMechanism:{
                page:1,
                pageSize:10,
            },
            totalCountMechanism:0,

            userList:[],
            isUserDialog:false,
            selectCompanyList:[],
            conditionDataUser:{
                page:1,
                pageSize:10,
            },
            totalCountCompany:0,


            isJobList:[
                {
                    label:'是',
                    value:true
                },{
                    label:'否',
                    value:false
                }
            ],
            financeStateList:[
                {
                    label:'未开票未回款',
                    value:0,
                },{
                    label:'未完成未开票',
                    value:1,
                },{
                    label:'已完成未开票',
                    value:2,
                },{
                    label:'已开票未回款',
                    value:10,
                },{
                    label:'已开票部分回款',
                    value:20,
                },{
                    label:'回款完成',
                    value:30,
                },{
                    label:'回款未开票',
                    value:40,
                },{
                    label:'红冲',
                    value:50,
                },{
                    label:'作废',
                    value:60,
                }
            ],
            financeStateAddList:[
                {
                    label:'未完成未开票',
                    value:1,
                },{
                    label:'已完成未开票',
                    value:2,
                }
            ],
            financialStatusList:[
                {
                    label:'已完成待开票',
                    value:40,
                },{
                    label:'已开票未回款',
                    value:41,
                },{
                    label:'已开票部分回款',
                    value:42,
                },{
                    label:'已回款未开票',
                    value:43,
                },{
                    label:'已回款未开票',
                    value:50,
                },{
                    label:'已完成已收款',
                    value:60,
                }
            ],

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
        this.queryMechanism();
    },
    methods:{
        async uploadFile(file){
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );

            let res = await api.uploadOther(file.file);
            let path = res;
            let option = {
                fileType:fileType,
                fileName:file.file.name,
                path:path,
            };
            if(this.isAddDialog){
                this.addData.paths.push(option)
            }else{
                this.updateData.paths.push(option)
            }
            this.$forceUpdate();
        },
        companyChange(row){

        },
        addDialogF(){
            this.isAddDialog = true;
            this.district = [];
        },
       
        selectDataMechanism(){
            this.conditionDataMechanism.page = 1;
            this.queryMechanism();
        },
        resetMechanism(){
            this.conditionDataMechanism = {
                page:1,
                pageSize:10,
            };
            this.queryMechanism();
        },
        // 机构列表
        async queryMechanism(){
            let res = await api.QueryMechanism(this.conditionDataMechanism);
            this.mechanismList = res.data.data.data;
            this.totalCountMechanism = res.data.data.totalCount;
        },
        // 机构分页
        handleCurrentChangeMechanism(page){
            this.conditionDataMechanism.page = page;
            this.queryMechanism();
        },


        // 公司列表
        async queryCompany(){
            let res = await api.queryPagerPersonPaiZhu(this.conditionDataUser);
            this.userList = res.data.data.data;
            this.totalCountCompany = res.data.data.totalCount;
        },
        // 公司分页
        handleCurrentChangeCompany(page){
            this.conditionDataUser.page = page;
            this.queryCompany();
        },


        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async exportExcel(){

this.conditionData.MechanismId=localStorage.getItem('mechanismid');
 let res = await api.exportPersonPaiZhuggf({
     "type": 13,
     "Condition": this.conditionData
 },'人员派驻信息');
 console.log(res);


}
,
        async loadingData() {
            let res  = await api.queryPagerPersonFeeRecord(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                caseNo:'',
                Name:null,
                Phone:null,
                MechanismName:null,
                Company:null,
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 选择地区
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.addData.district = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.addData.district = this.addData.district+','+CodeToText[codeArray[1]]
            }
            if(codeArray[2]){
                this.addData.district = this.addData.district+','+CodeToText[codeArray[2]]
            }
        },
        handleUpdateRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.district = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.updateData.district = this.updateData.district+','+CodeToText[codeArray[1]]
            }
            if(codeArray[2]){
                this.updateData.district = this.updateData.district+','+CodeToText[codeArray[2]]
            }
        },
        // 选择机构
        selectMechanism(row){
            if(this.isAddDialog){
                this.addData.mechanismId = row.id;
                this.addData.mechanismName = row.jianCheng;
            }else{
                this.updateData.mechanismId = row.id;
                this.updateData.mechanismName = row.jianCheng;
            }
            
            this.isMechanismDialog = false;
        },
        
        async addPersonFeeRecord(){
            this.addData.bzFee = parseFloat(this.addData.bzFee);
            this.addData.sjFee = parseFloat(this.addData.sjFee);
            this.addData.paths = JSON.stringify(this.addData.paths);
            this.isAddDialog = false;
            
            let res = await api.addPersonFeeRecord(this.addData);
            this.addData = {
                paths:[],
            };
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.addData = {
                    paths:[],
                };
                this.district = [];
                this.loadingData();
            }
        },

        async updatePerson(){
            this.updateData.bzFee = parseFloat(this.updateData.bzFee);
            this.updateData.sjFee = parseFloat(this.updateData.sjFee);
            this.updateData.paths = JSON.stringify(this.updateData.paths);
            this.isUpdateDialog = false;
            let res = await api.updatePersonFeeRecord(this.updateData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.loadingData();
            }
        },

        // 编辑弹框
        editDialog(row){
            this.isUpdateDialog = true;
            this.updateData = row;
            this.updateData.paths = JSON.parse(row.paths?row.paths:'[]');
            let districtText = this.updateData.district.split(',')
            if(districtText[2]){
                this.district = [TextToCode[districtText[0]].code,TextToCode[districtText[0]][districtText[1]].code,TextToCode[districtText[0]][districtText[1]][districtText[2]].code];
                return;
            }
            if(districtText[1]){
                this.district = [TextToCode[districtText[0]].code,TextToCode[districtText[0]][districtText[1]].code ];
            }
            this.$forceUpdate();
        },
        // 导入excel
        async importExcel(file){
            let res = await api.importFreeRecord(file.file,{
                Type:20,
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功'
                });
                this.loadingData();
            }
        },
        // 下载模板
        downloadExcel(){
            const elt = document.createElement('a');
            elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220406/20220406170510a78Gp/意健险人员派驻');
            elt.setAttribute('download', '批量新增模板.xls');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        // 下载资料
        download(path,name){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        async clearAllItemMaterial(index){
            if(this.isUpdateDialog){
                this.updateData.paths.splice(index,1);
            }
            if(this.isAddDialog){
                this.addData.paths.splice(index,1);
            }
        },


        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },

        deleteItem(item){
            this.$confirm('确认删除资料, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteItemApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },

        async deleteItemApi(item){
            let res = await api.deletePersonFeeRecord(item.id);
            
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .tb-red{
            color:red;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            .handle-r{
                display: flex;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
                display: flex;
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        align-items: center;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            padding-top: 15px;
            padding-bottom: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            float: left;
            span{
                display: flex;
                flex-wrap: wrap;
            }
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
            .el-button--mini, .el-button--mini.is-round{
                padding-bottom: 0px;
                padding-top: 4px;
            }
        }
    }

    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
</style>
